export default __webpack_public_path__ + "static/tag-dont-3-light-5d05809966997af4ac34c42ca376dd53.png";